import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import SEO from "../components/SEO";
import axios from "axios";
import { API } from "../App";

export default function Locations() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    try {
      const response = await axios.get(`${API}/locations`);
      setLocations(response.data);
    } catch (error) {
      console.error("Error fetching locations:", error);
    } finally {
      setLoading(false);
    }
  };

  // Group locations by region
  const groupedLocations = locations.reduce((acc, loc) => {
    const region = loc.region || "Other";
    if (!acc[region]) {
      acc[region] = [];
    }
    acc[region].push(loc);
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-background py-12 px-4 md:px-8" data-testid="locations-page">
      <SEO 
        url="/locations"
        title="Cape Town Locations"
        description="Find creative professionals in your area. Browse videographers and film crew by Cape Town location: Sea Point, Camps Bay, Woodstock, Constantia, and more."
        keywords={["cape town film locations", "videographer sea point", "cinematographer camps bay", "film crew woodstock"]}
      />
      
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="font-heading text-title uppercase">
            CAPE TOWN <span className="text-orange-500">LOCATIONS</span>
          </h1>
          <p className="text-zinc-500 mt-2">
            Find creative professionals in your area
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-60 bg-zinc-900 skeleton" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Object.entries(groupedLocations).map(([region, regionLocations]) => (
              <div key={region} className="bg-zinc-900 border border-zinc-800 p-6">
                <h3 className="font-heading text-xl text-white mb-4">{region}</h3>
                <div className="space-y-2">
                  {regionLocations.map((location) => (
                    <Link
                      key={location.location_id}
                      to={`/locations/${location.slug}`}
                      className="w-full flex items-center justify-between p-3 hover:bg-zinc-800 transition-colors text-left group"
                      data-testid={`location-${location.slug}`}
                    >
                      <div className="flex items-center gap-3">
                        <MapPin className="h-4 w-4 text-orange-500" />
                        <span className="text-zinc-300 group-hover:text-white transition-colors">
                          {location.name}
                        </span>
                      </div>
                      <span className="font-mono text-xs text-zinc-600">
                        {location.profile_count || 0}
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
